import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCircle, faCog, faSync } from '@fortawesome/pro-solid-svg-icons';
import { Dropdown, MenuItem } from 'react-bootstrap';

import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';

export default class ActiveIntegrationsCard extends React.Component {

  static propTypes = {
    children: PropTypes.object.isRequired,
    image: PropTypes.string.isRequired,
    pushContactsToSource: PropTypes.bool,
    onCancel: PropTypes.func,
    onEdit: PropTypes.func,
    onImport: PropTypes.func,
    onPush: PropTypes.func,
  }

  renderIntegrationActions() {
    const {
      pushContactsToSource,
      onEdit,
      onCancel,
      onImport,
      onPush,
    } = this.props;

    return (
      <Dropdown className="mt-2 actions-dropdown" id="action-dropdown">
        <UnstyledDropdownToggle
          bsRole="toggle"
          className="left-buffer-md"
          id="project-action-button"
          variant="dark"
        >
          <FontAwesomeIcon className="text-muted" icon={faCog} size="lg"/>
        </UnstyledDropdownToggle>
        <Dropdown.Menu>
          {onEdit &&
            <MenuItem eventKey="switch-db-event" id="switch-db-btn" onClick={onEdit}>
              <span>Switch Database</span>
            </MenuItem>
          }
          <MenuItem eventKey="disconnect-event" id="disconnect-btn" onClick={onCancel}>
            <span>Disconnect Account</span>
          </MenuItem>
          {onImport &&
            <MenuItem eventKey="import-event" id="import-btn" onClick={onImport}>
              <span>Import</span>
            </MenuItem>
          }
          {(onPush && pushContactsToSource) &&
            <MenuItem eventKey="push-event" id="push-btn" onClick={onPush}>
              <span>Push Contacts</span>
            </MenuItem>
          }
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderIntegratedButtons() {
    const { onCancel } = this.props;
    return (
      <div className="col-xs-3 clearfix">
        {onCancel && this.renderIntegrationActions()}
        {this.renderConnectedBox()}
      </div>
    );
  }

  renderConnectedBox() {
    return (
      <div className="connected-btn status-box">
        <div className="fa-layers fa-fw inner-icons">
          <FontAwesomeIcon className="completed-circle" icon={faCircle}/>
          <FontAwesomeIcon
            icon={faCheck}
            transform="shrink-8"
          />
        </div>
        <span className="pl-2">CONNECTED</span>
      </div>
    );
  }

  render() {
    const {
      children,
      image
    } = this.props;

    return (
      <React.Fragment>
        <hr className="ml-0 mr-0 mt-3 mb-3"/>
        <div className="d-flex">
          <div className="col-xs-1">
            <img className="img-thumbnail" src={image}/>
          </div>
          {children}
          {this.renderIntegratedButtons()}
        </div>
      </React.Fragment>
    );
  }
}
